var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap-data-list" },
    [
      _c("p", { staticClass: "title-data-list" }, [
        _vm._v("Experience Manager")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs" },
        _vm._l(_vm.tabs, function(tab) {
          return _c(
            "div",
            {
              key: tab.id,
              staticClass: "tab",
              class: { "tab-active": tab.id === _vm.tabSelected },
              on: {
                click: function($event) {
                  _vm.tabSelected = tab.id
                }
              }
            },
            [_vm._v("\n      " + _vm._s(tab.text) + "\n    ")]
          )
        })
      ),
      _vm._v(" "),
      _vm.isLoading ? _c("j-loading-trigger-list") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "exp-manager" },
            [
              _vm.datas.length > 0
                ? _vm._l(_vm.datas, function(data) {
                    return _c(
                      "div",
                      { key: data.id, staticClass: "data-list" },
                      [
                        _c("div", { staticClass: "section-left" }, [
                          _c("img", {
                            attrs: {
                              alt: "icon-list-" + data.id,
                              src: require("@/assets/icon-sidebar/experience-manager.svg"),
                              width: "20",
                              height: "20"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "exp-id" }, [
                            _vm._v(_vm._s(data.id))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "wrap-exp-type" }, [
                            _c("div", { staticClass: "exp-type" }, [
                              _vm._v(_vm._s(_vm.tabSelected))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "exp-name" }, [
                            _vm._v(_vm._s(data.name))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-right" }, [
                          _c("div", { staticClass: "lines" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "wrap-btn-action mr-2" },
                                [
                                  _vm._m(0, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tooltip-component" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "wrap-timestamp" },
                                        [
                                          _vm._m(1, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "timestamp" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatFullDateTime(
                                                      data.created_at
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatFullDateTime(
                                                      data.updated_at
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "wrap-btn-action mr-2" },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-external-link",
                                    staticStyle: { "margin-top": "6px" },
                                    on: {
                                      click: function($event) {
                                        _vm.onOpenNewTab(data)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tooltip-component" },
                                    [_vm._v("Open new tab")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "wrap-btn-action" }, [
                                _c("i", {
                                  staticClass: "fa fa-trash",
                                  on: {
                                    click: function($event) {
                                      _vm.onDeleteExpManager(data)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tooltip-component" },
                                  [_vm._v("Delete experience manager")]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.datas.length === 0
                ? _c("p", { staticClass: "data-not-found" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.isHaveData
                            ? "All data has been displayed"
                            : "No " +
                                _vm.tabSelected +
                                " experience manager registered"
                        ) +
                        "\n    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isHaveData
                ? _c("div", { staticClass: "custom-pagination" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn-previous",
                        style: [
                          _vm.page === 1
                            ? { opacity: "0.5", cursor: "not-allowed" }
                            : ""
                        ],
                        on: { click: _vm.previousPage }
                      },
                      [_c("i", { staticClass: "fa fa-chevron-left" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-forward",
                        style: [
                          _vm.datas.length < 100
                            ? { opacity: "0.5", cursor: "not-allowed" }
                            : ""
                        ],
                        on: { click: _vm.nextPage }
                      },
                      [_c("i", { staticClass: "fa fa-chevron-right" })]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-icon" }, [
      _c("i", { staticClass: "fa fa-info", staticStyle: { cursor: "default" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "timestamp-type" }, [
      _c("p", [_vm._v("Created")]),
      _vm._v(" "),
      _c("p", [_vm._v("Updated")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-375326d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375326d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormExpManager.vue
// module id = null
// module chunks = 